
export const parseLocalDate = (dateString: string): Date => {
  const [year, month, day] = dateString.split('-').map(Number);
  
  return new Date(year, month - 1, day);
};


export const parseSafeLocalDate = (dateString: string | null | undefined): Date | null => {
  if (!dateString) return null;
  
  try {
    const datePart = dateString.split(' ')[0];
    const date = parseLocalDate(datePart);
    
    return isNaN(date.getTime()) ? null : date;
  } catch {
    return null;
  }
};


export const formatDate = (date: Date): string => {
  return date.toLocaleDateString('en-US', { 
    year: 'numeric', 
    month: '2-digit', 
    day: '2-digit' 
  });
};


export const formatDateString = (dateString: string): string => {
  const date = parseSafeLocalDate(dateString);
  return date ? formatDate(date) : '';
};